import React from 'react'
import { LearnMoreLink } from 'src/components/Reusable/Text/Link'
import { FlexRow, FlexAlign } from 'src/components/Reusable/Flex'
import { IndexPageActionsContainer } from '../PageLayout.styles'

export const IndexPageActions = ({
  description,
  learnMoreUrl,
  buttonGroup,
  afterLearnMore,
}: {
  description: React.ReactNode
  learnMoreUrl?: string
  buttonGroup?: React.ReactNode
  afterLearnMore?: React.ReactNode
}): JSX.Element => {
  return (
    <IndexPageActionsContainer>
      <FlexRow align={FlexAlign.CENTER} gap={8} $wrap="wrap">
        {description}
        {learnMoreUrl && <LearnMoreLink href={learnMoreUrl} />}
        {afterLearnMore}
      </FlexRow>
      {buttonGroup}
    </IndexPageActionsContainer>
  )
}
